import { useStore } from 'effector-react'
import { useEffect } from 'react'

import {
  $loadError,
  $savingId,
  $subscriptions,
  emailsTabMounted,
  getSubscriptions,
} from './model'

export const useEmailsSubscriptions = (clientId: string) => {
  useEffect(() => {
    emailsTabMounted(clientId)
  }, [clientId])

  const subscriptions = useStore($subscriptions)
  const loading = useStore(getSubscriptions.pending)
  const loadError = useStore($loadError)
  const savingId = useStore($savingId)

  return {
    subscriptions,
    loading,
    loadError,
    savingId,
  }
}
